module Hereabout.Data.Route where

import Prelude

import Data.Either (note)
import Data.Generic.Rep (class Generic)
import Data.Maybe (Maybe)
import Data.Number as N
import Hereabout.Types (AreaCommunityDetails(..), CommunityFeed(..), Event(..), VenueFeed(..), EventWithComments(..))
import Routing.Duplex (RouteDuplex', as, default, root, segment, string)
import Routing.Duplex.Generic (noArgs, sum)
import Routing.Duplex.Generic.Syntax ((/))

data Route
  = CommunityRoute String
  | CommunityRouteVenueTab String
  | VenueRoute String
  | EventRoute String
  | CommunityListRoute
  | PrivacyPolicyRoute
  | TermsOfServiceRoute
  | GPSFeedRoute
  | UserProfileRoute



instance showRoute :: Show Route where
  show CommunityListRoute = "clr"
  show (CommunityRoute _) = "cr"
  show (CommunityRouteVenueTab _) = "crvt"
  show (EventRoute _) = "er"
  show (VenueRoute _) = "vr"
  show (GPSFeedRoute) = "gpsr"
  show (PrivacyPolicyRoute) = "ppr"
  show (TermsOfServiceRoute) = "tosr"
  show (UserProfileRoute) = "upr"

data CommunityFeedTab
  = CommunityFeedEventTab
  | CommunityFeedVenueTab

derive instance eqCommunityFeedTab :: Eq CommunityFeedTab
derive instance ordCommunityFeedTab :: Ord CommunityFeedTab

data HereaboutPage
  = CommunityFeedPage CommunityFeed CommunityFeedTab
  | VenuePage VenueFeed
  | EventPage (EventWithComments String)
  | CommunityListPage (Array AreaCommunityDetails)
  | GPSFeedPage
  | PrivacyPolicyPage
  | TermsOfServicePage
  | UserProfilePage
  | EmptyPage

title :: HereaboutPage -> String
title (CommunityFeedPage (CommunityFeed cf ) _) = cf.name <> " | Hereabout"
title (VenuePage (VenueFeed vf )) = vf.name <> " | Hereabout"
title (EventPage (EventWithComments e )) = e.name <> " | Hereabout"
title (CommunityListPage _) = "Communities | Hereabout"
title GPSFeedPage = "Feed | Hereabout"
title PrivacyPolicyPage = "Privacy Policy | Hereabout"
title TermsOfServicePage = "Terms of Service | Hereabout"
title UserProfilePage = "My Profile | Hereabout"
title EmptyPage = "Hereabout"

derive instance genericRoute :: Generic Route _
derive instance eqRoute :: Eq Route
derive instance ordRoute :: Ord Route

routeCodec :: RouteDuplex' Route
routeCodec =
  default GPSFeedRoute $ root $ sum
    { "CommunityListRoute"           : "communities" / noArgs
    , "CommunityRoute"               : "feed" / "community" / string segment
    , "CommunityRouteVenueTab"       : "feed" / "community" / string segment / "venues"
    , "VenueRoute"                   : "feed" / "venue" / string segment
    , "EventRoute"                   : "event" / string segment
    , "PrivacyPolicyRoute"           : "privacy" / noArgs
    , "TermsOfServiceRoute"          : "terms" / noArgs
    , "UserProfileRoute"             : "profile" / noArgs
    , "GPSFeedRoute"                 : noArgs
    }

number :: RouteDuplex' String -> RouteDuplex' Number
number = as show (N.fromString >>> note "Bad Number")
